import { Model } from 'modules/core/lib/mobx-rest'

import { MEMBERS, RELATIVE_ROLE, USER } from 'modules/approvals/lib/roles'

export interface IStepApprover {
  id: number
  access_group_name: string
  approver_id: number
  approval_step_position: string
  approval_step_id: number
  approval_step_strategy: string
  approver_groupable_type?: string
  approver_groupable_id?: number
}
class StepApprover extends Model<IStepApprover> {
  static urlRoot() {
    return '/approvals/approval_step_approvers'
  }

  get id(): number {
    return this.attributes.id
  }

  get groupName(): string {
    return this.attributes.access_group_name
  }

  get approverId(): number {
    return this.attributes.approver_id
  }

  get role(): string {
    if (this.groupName === MEMBERS) return USER

    return RELATIVE_ROLE
  }

  get approvalStepPosition(): string {
    return this.attributes.approval_step_position
  }

  get approvalStepId(): number {
    return this.attributes.approval_step_id
  }

  get approvalStepStrategy(): string {
    return this.attributes.approval_step_strategy
  }

  get approverGroupableType(): string | undefined {
    return this.attributes.approver_groupable_type
  }

  get approverGroupableId(): number | undefined {
    return this.attributes.approver_groupable_id
  }
}

export default StepApprover
